import { z } from 'zod';
import { createStandardNotificationData } from '@/src/shared/data/schemas/payloads/base';

export const SChatNotificationPayload = createStandardNotificationData({
  branch_id: z.string(),
});
export type TChatNotificationPayload = z.infer<typeof SChatNotificationPayload>;
